import { useMemo } from "react";
import { FEASIBILITY_STATUS } from "../../../../../constants";
import { TFeasibilityStatus } from "../../../../../types";
import styles from "./styles.module.css";

interface Props {
  feasibilityStatus: TFeasibilityStatus;
  handleClick: () => void;
  onItemClick: (value: string) => void;
  isMenuOpen: boolean;
}

export const FeasibilityAdornment = ({
  feasibilityStatus = "unknown",
  onItemClick,
  isMenuOpen,
  handleClick,
}: Props) => {
  const chosenStatus = useMemo(
    () => (feasibilityStatus === "unknown" ? "Не выбрано" : feasibilityStatus),
    [feasibilityStatus],
  );

  const statusArray = useMemo(
    () => FEASIBILITY_STATUS.filter((status) => status !== feasibilityStatus),
    [chosenStatus],
  );

  return (
    <div onClick={handleClick} className={styles["adornment"]}>
      <div className={styles["adornment-content"]}>{chosenStatus}</div>
      {isMenuOpen && (
        <ul className={styles["menu"]}>
          {statusArray.map((status) => (
            <li
              onClick={() => {
                onItemClick(status);
                handleClick();
              }}
              className={styles["menu-item"]}
            >
              {status === "unknown" ? "Не выбрано" : status}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
